module.exports = __webpack_public_path__ + "static/media/marker-todo.2aea1820.png";